import { ReadPage } from './ReadPage';
export default ReadPage;
